(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('shiftDayBreak', {
        templateUrl: 'views/components/views/shiftDayBreak/shiftDayBreak.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', '$q', 'stateService', 'utilityService', 'modalService', 'translateService', 'shiftDayBreakService', 'shiftService', function ($stateParams, $q, stateService, utilityService, modalService, translateService, shiftDayBreakService, shiftService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let shiftId = $stateParams.shift_id;
            let shiftBreakKeyno = $stateParams.shiftbreak_keyno;
            let dayNo = $stateParams.dayno;
            let inProgress = false;
            let loadCounter = 0;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                edit: {
                    shift_id: shiftId
                },
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            translateService.translateBatch(translations).then(function (data) {
                angular.forEach(translations, function (_, key) {
                    if (angular.isDefined(data[key])) {
                        translations[key] = data[key];
                    }
                });
            });

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTIONS

            let loadEdit = function () {
                const deferred = $q.defer();

                shiftDayBreakService.getEdit({
                    shiftbreak_keyno: shiftBreakKeyno,
                    shift_id: shiftId,
                    dayno: dayNo
                }).then(function (info) {
                    angular.copy(info[0], vm.model.edit);

                    $q.all([
                        loadWeekDays()
                    ]).then(() => deferred.resolve());
                });

                return deferred.promise;
            };

            let loadWeekDays = function () {
                let itemsListWeekDays = [];

                shiftService.listWeekDays({ shift_id: shiftId }).then(function (list) {
                    angular.forEach(list, function (item) {
                        itemsListWeekDays[item.item_id] = item;
                    });

                    vm.model.edit.day_name = itemsListWeekDays[dayNo].item_name;
                });
            };

            // #endregion LOAD PROCEDURE FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                var d = {};
                var keys = Object.keys(vm.model.edit);

                angular.forEach(keys, function (key) {
                    d[key] = vm.model.edit[key];
                });

                d['shift_id'] = shiftId;
                d['dayno'] = dayNo;

                shiftDayBreakService.saveObj(d).then(function (response) {
                    if (response[0].status_no !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                            message: response[0].status_message,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL
            
            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    shiftDayBreakService.deleteItem({ shiftbreak_keyno: vm.model.edit.shiftbreak_keyno }).then(function (response) {
                        if (response[0].status_no !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                                message: response[0].status_message,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        }
                    }, function () {
                        vm.model.lockedDelete = false;
                    });
                }, function () {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL
            
            let validateHours = function () {
                inProgress = true;
                var d = {};
                var keys = Object.keys(vm.model.edit);

                angular.forEach(keys, function (key) {
                    d[key] = vm.model.edit[key];
                });

                shiftDayBreakService.validateBreakHour(d).then(function (response) {
                    inProgress = false;
                    vm.model.edit.breakhour = response[0].breakhour;
                });
            };
            
            let lazyValidate = function () {
                if (inProgress) {
                    if (loadCounter < 100) {
                        loadCounter = loadCounter + 1;
                        utilityService.sleep(50);
                        lazyValidate();
                    }
                } else {
                    validateHours();
                }
            };

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'from_time':
                    case 'to_time':
                        if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

                        vm.model.edit[id] = value;

                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                        loadCounter = 0;
                        lazyValidate();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadEdit();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
